import {Component, Input, OnInit} from '@angular/core';
import { LocalLocationContainerConfiguration } from '../../local-loads/shared/local-location-container-configuration.model';

@Component({
  selector: 'app-sap-flags-list',
  templateUrl: './sap-flags-list.component.html',
  styleUrls: ['./sap-flags-list.component.scss']
})
export class SapFlagsListComponent implements OnInit {

  @Input()
  containerConfiguration: LocalLocationContainerConfiguration;

  constructor() { }

  ngOnInit() {
  }

}
